const local: App.I18n.Schema = {
    view: {
        grid: "Grid",
        list: "List",
        compact: "Compact",
    },
    support: {
        title: "Support Center",
        description: "Get help and manage your support tickets",
        myTickets: "My Tickets",
        createTicket: "Create Ticket",
        agent: "Support",

        // Navigation
        navigation: {
            dashboard: "Dashboard",
            createTicket: "Create Ticket",
            myTickets: "My Tickets",
            allTickets: "All Tickets",
            openTickets: "Open Tickets",
            inProgress: "In Progress",
            resolved: "Resolved",
        },

        // Ticket properties
        ticket: {
            subject: "Subject",
            description: "Description",
            status: "Status",
            priority: "Priority",
            category: "Category",
            createdAt: "Created",
            updatedAt: "Updated",
            assignedTo: "Assigned To",
            ticketNumber: "Ticket #",
            replies: "Replies",
            attachments: "Attachments",
            details: "Ticket Details",
            information: "Ticket Information",
            createdBy: "Created By",
            resolvedAt: "Resolved At",
            slaDueAt: "SLA Due At",
            internalNotes: "Internal Notes",
        },

        // Status values
        statuses: {
            open: "Open",
            inProgress: "In Progress",
            waitingCustomer: "Waiting for Customer",
            resolved: "Resolved",
            closed: "Closed",
        },

        // Status values (alternative format for compatibility)
        status: {
            open: "Open",
            in_progress: "In Progress",
            waiting_customer: "Waiting for Customer",
            resolved: "Resolved",
            closed: "Closed",
        },

        // Priority values
        priorities: {
            low: "Low",
            medium: "Medium",
            high: "High",
            critical: "Critical",
        },

        // Priority values (alternative format for compatibility)
        priority: {
            low: "Low",
            medium: "Medium",
            high: "High",
            critical: "Critical",
        },

        // Categories
        categories: {
            title: "Support Categories",
            technical: "Technical Issue",
            billing: "Billing",
            account: "Account",
            feature: "Feature Request",
            bug: "Bug Report",
            other: "Other",
        },

        // Actions
        actions: {
            create: "Create Ticket",
            reply: "Reply",
            attach: "Attach File",
            filter: "Filter",
            search: "Search tickets...",
            submit: "Submit",
            cancel: "Cancel",
            save: "Save",
            edit: "Edit",
            delete: "Delete",
            close: "Close Ticket",
            reopen: "Reopen Ticket",
            closeTicket: "Close Ticket",
            reopenTicket: "Reopen Ticket",
            moreActions: "More Actions",
            assign: "Assign",
            viewDetails: "View Details",
            downloadAttachment: "Download",
            viewAll: "View All",
            back: "Back",
            changeStatus: "Change Status",
            changePriority: "Change Priority",
            download: "Download",
            searchAll: "Search all tickets...",
            clearFilters: "Clear Filters",
            retryNow: "Retry Now",
            refresh: "Refresh",
            ticketsRefreshed: "Tickets refreshed",
            createTicket: "Create Ticket",
            yes: "Yes",
            no: "No",
        },

        // Forms
        forms: {
            subjectPlaceholder: "Enter ticket subject",
            descriptionPlaceholder: "Describe your issue in detail...",
            replyPlaceholder: "Type your reply...",
            selectCategory: "Select a category",
            selectPriority: "Select priority",
            fileUpload: "Upload files",
            dragDropFiles: "Drag and drop files here or click to browse",
            maxFileSize: "Maximum file size: {size}MB",
            allowedTypes: "Allowed file types: {types}",
            useTemplate: "Use Template",
            selectTemplate: "Select a template",
            cannedResponses: "Canned Responses",
            selectCannedResponse: "Select a canned response",
        },

        // Filters
        filters: {
            title: "Filters",
            status: "Status",
            priority: "Priority",
            category: "Category",
            dateRange: "Date Range",
            assignedTo: "Assigned To",
            createdBy: "Created By",
            clearFilters: "Clear Filters",
            applyFilters: "Apply Filters",
            showFilters: "Show Filters",
            hideFilters: "Hide Filters",
            activeFilters: "Active Filters",
            search: "Search",
            unassigned: "Unassigned",
            assignedToMe: "Assigned to Me",
            assignee: "Assignee",
        },

        // View modes
        viewModes: {
            grid: "Grid View",
            list: "List View",
        },

        // Views
        views: {
            grid: "Grid",
            list: "List",
        },

        // Sorting
        sorting: {
            newest: "Newest First",
            oldest: "Oldest First",
            priority: "Priority",
            status: "Status",
            updated: "Recently Updated",
            createdAt: "Created Date",
            updatedAt: "Updated Date",
            subject: "Subject",
        },

        // Messages
        messages: {
            noTickets: "No tickets found",
            noTicketsDescription: "You haven't created any support tickets yet.",
            ticketCreated: "Ticket created successfully",
            ticketUpdated: "Ticket updated successfully",
            replyAdded: "Reply added successfully",
            fileUploaded: "File uploaded successfully",
            ticketClosed: "Ticket closed successfully",
            ticketReopened: "Ticket reopened successfully",
            confirmCloseTicket: "Are you sure you want to close this ticket? This will prevent further replies until the ticket is reopened.",
            confirmReopenTicket: "Are you sure you want to reopen this ticket? This will allow new replies to be added.",
            errorClosingTicket: "Failed to close ticket",
            errorReopeningTicket: "Failed to reopen ticket",
            loadingTickets: "Loading tickets...",
            loadingTicket: "Loading ticket details...",
            errorLoadingTickets: "Failed to load tickets",
            errorLoadingTicket: "Failed to load ticket details",
            errorCreatingTicket: "Failed to create ticket",
            errorAddingReply: "Failed to add reply",
            statusUpdated: "Status updated successfully",
            errorUpdatingStatus: "Failed to update status",
            priorityUpdated: "Priority updated successfully",
            errorUpdatingPriority: "Failed to update priority",
            ticketAssigned: "Ticket assigned successfully",
            errorAssigningTicket: "Failed to assign ticket",
            ticketNotFound: "Ticket Not Found",
            ticketNotFoundDesc: "The ticket you're looking for doesn't exist or you don't have permission to view it.",
            retrySuccess: "Operation completed successfully",
            retryFailed: "Retry failed. Please try again.",
            resetSuccess: "Reset completed successfully",
            resetFailed: "Reset failed. Please try again.",
            ticketsRefreshed: "Tickets refreshed successfully",
            loadError: "Failed to load data. Please try again.",
            searchError: "Search failed. Please try again.",
            feedbackError: "Failed to submit feedback. Please try again.",
        },

        // Dashboard
        dashboard: {
            title: "Support",
            overview: "Overview",
            myStats: "My Statistics",
            recentActivity: "Recent Activity",
            quickActions: "Quick Actions",
            totalTickets: "Total Tickets",
            openTickets: "Open Tickets",
            resolvedTickets: "Resolved Tickets",
            avgResponseTime: "Avg Response Time",
        },

        // Ticket details
        ticketDetails: {
            conversation: "Conversation",
            information: "Ticket Information",
            createdBy: "Created by",
            assignedTo: "Assigned to",
            lastUpdated: "Last updated",
            timeSpent: "Time spent",
            slaStatus: "SLA Status",
            onTime: "On Time",
            overdue: "Overdue",
            dueIn: "Due in {time}",
        },

        // Message and reply types
        message: {
            original: "Original Message",
        },

        replyType: {
            public: "Public",
            internal: "Internal",
        },

        // Reply form labels
        reply: {
            type: "Reply Type",
            public: "Public Reply",
            internal: "Internal Note",
        },

        // Replies section
        replies: {
            title: "Replies",
            add: "Add Reply",
        },

        // Attachments section
        attachments: {
            title: "Attachments",
        },

        // Knowledge Base
        knowledgeBase: {
            needHelp: "Need Help?",
            title: "Knowledge Base",
            articles: "articles",
            popularArticles: "Popular Articles",
            views: "views",
            helpful: "helpful",
            noArticles: "No Articles Found",
            noArticlesDesc: "There are no articles available at this time.",
            noArticlesInCategory: "This category doesn't have any articles yet.",
            stillNeedHelp: "Still Need Help?",
            wasHelpful: "Was this article helpful?",
            yes: "Yes",
            no: "No",
            thanksFeedback: "Thanks for your feedback!",
            sorryNotHelpful: "Sorry this wasn't helpful. Please contact support for more assistance.",
            searchPlaceholder: "Search articles...",
            browseByCategory: "Browse by Category",
            searchResults: "Search Results",
            noResults: "No Results Found",
            noResultsDesc: "No articles matched your search. Try different keywords.",
        },
       

        // File upload
        fileUpload: {
            selectFiles: "Select Files",
            uploadFiles: "Upload Files",
            uploading: "Uploading...",
            uploadComplete: "Upload complete",
            uploadFailed: "Upload failed",
            removeFile: "Remove file",
            fileSize: "File size",
            fileName: "File name",
            errors: {
                fileTooLarge: "File is too large. Maximum size is {maxSize}",
                invalidFileType: "Invalid file type",
                fileAlreadyAdded: "File has already been added"
            },
            messages: {
                uploadSuccess: "{count} file(s) uploaded successfully",
                uploadFailed: "{count} file(s) failed to upload",
                uploadError: "An error occurred during upload"
            }
        },

        // Polling
        polling: {
            maxRetriesExceeded: "Maximum retry attempts exceeded. Polling stopped.",
            fetchError: "Failed to fetch data",
            tooManyRequests: "Too many requests",
            tooManyRequestsDesc: "Too many requests. Please wait a moment and try again. We've temporarily limited requests to ensure system stability.",
        },

        // Errors
        errors: {
            networkError: "Network Error",
            permissionError: "Permission Denied",
            notFoundError: "Not Found",
            genericError: "Something went wrong",
            timeoutError: "Request Timeout",
            serverError: "Server Error",
            maintenanceError: "Under Maintenance",
            networkErrorDesc: "Unable to connect to the server. Please check your internet connection and try again.",
            permissionErrorDesc: "You don't have permission to access this resource. Please contact your administrator.",
            notFoundErrorDesc: "The requested resource could not be found.",
            genericErrorDesc: "An error occurred while loading data. Please try again.",
            timeoutErrorDesc: "The request took too long to complete. Please try again.",
            serverErrorDesc: "The server encountered an error (502). Please try again later or contact support if the issue persists.",
            maintenanceErrorDesc: "The system is currently undergoing maintenance. Please try again later.",
            withErrorCode: "{message} (Error: {code})",
            tryAgain: "Try Again",
            contactSupport: "Contact Support",
        },

        // Auth required
        authRequired: {
            title: "Authentication Required",
            description: "Please log in to access the support system and manage your tickets.",
            loginButton: "Log In",
        },

        // Empty states
        emptyStates: {
            noTickets: {
                title: "No tickets found",
                description: "Create your first support ticket to get started.",
                action: "Create Ticket",
            },
            noReplies: {
                title: "No replies yet",
                description: "Be the first to reply to this ticket.",
            },
            noAttachments: {
                title: "No attachments",
                description: "No files have been attached to this ticket.",
            },
            noSearchResults: {
                description: "Try adjusting your search terms or filters.",
            },
            noData: {
                description: "No data available.",
            },
        },

        // Validation
        validation: {
            subjectRequired: "Subject is required",
            descriptionRequired: "Description is required",
            categoryRequired: "Please select a category",
            priorityRequired: "Please select a priority",
            fileTooBig: "File {fileName} is too large. Maximum size is {size}MB",
            tooManyFiles: "Too many files. Maximum is {max} files",
            invalidFileType: "File {fileName} has invalid type. Allowed types: {allowedTypes}",
            maxFilesExceeded: "Maximum number of files exceeded",
            formErrors: "Please fix the form errors before submitting",
            replyRequired: "Reply content is required",
            // Dynamic field validation
            fieldRequired: "Field {field} is required",
            invalidCardNumber: "Invalid card number",
            invalidIBAN: "Invalid IBAN number",
            invalidNumber: "Invalid number",
            numberTooSmall: "Number must be at least {min}",
            numberTooLarge: "Number must not exceed {max}",
            invalidDate: "Invalid date",
            invalidEmail: "Invalid email address",
            textTooShort: "Text must be at least {min} characters",
            textTooLong: "Text must not exceed {max} characters",
            invalidFormat: "Invalid format",
            invalidOption: "Invalid option selected",
            addressRequired: "Address selection is required",
            invalidAddress: "Invalid address selected",
        },

        // Help section
        help: {
            beforeCreating: "Before Creating a Ticket",
            searchKnowledge: "Search our knowledge base for quick answers to common questions.",
            tips: "Tips for Better Support",
            tip1: "Be specific about your issue and include relevant details",
            tip2: "Attach screenshots or files that help explain the problem",
            tip3: "Choose the correct category and priority for faster resolution",
            urgentIssues: "Urgent Issues",
            urgentContact: "For critical issues that need immediate attention, contact our support team directly.",
            contactSupport: "Contact Support",
        },

        // Stats for agent dashboard
        stats: {
            total: "Total",
            unassigned: "Unassigned",
            assignedToMe: "Assigned to Me",
            open: "Open",
            inProgress: "In Progress",
            overdue: "Overdue",
            openTickets: "Open Tickets",
        },

        // Agent Dashboard
        agentDashboard: {
            title: "Agent Dashboard",
            viewAllTickets: "View All Tickets",
            myQueue: "My Queue",
            unassignedQueue: "Unassigned Queue",
            ticketsNeedingAttention: "Tickets Needing Attention",
        },

        // Role labels
        roles: {
            agent: "Agent",
            admin: "Admin",
            user: "User",
        },

        // Access denied
        accessDenied: {
            title: "Access Denied",
            agentRequired: "You need agent or admin privileges to access this page.",
        },

        // All Tickets view
        allTickets: "All Tickets",

        // Agent actions
        agentActions: {
            title: "Agent Actions",
            noAgentsAvailable: "No agents available",
            assignToMe: "Assign to Me",
            unassign: "Unassign",
        },

        // Bulk Actions
        bulkActions: {
            selectedCount: "{count} ticket(s) selected",
            changeStatus: "Change Status",
            changePriority: "Change Priority",
            assign: "Assign",
            unassign: "Unassign",
            clearSelection: "Clear Selection",
            statusChangeSuccess: "{count} ticket(s) status updated successfully",
            statusChangeFailed: "Failed to update ticket status",
            priorityChangeSuccess: "{count} ticket(s) priority updated successfully",
            priorityChangeFailed: "Failed to update ticket priority",
            assignSuccess: "{count} ticket(s) assigned successfully",
            unassignSuccess: "{count} ticket(s) unassigned successfully",
            assignFailed: "Failed to assign tickets",
            // Loading messages
            updatingStatus: "Updating ticket status...",
            updatingPriority: "Updating ticket priority...",
            updatingAssignment: "Updating ticket assignment...",
            processing: "Processing...",
            selectTickets: "bulk actions",
            cancelSelect: "Cancel",
        },

        // Activity Timeline
        activity: {
            title: "Activity Timeline",
            noActivity: "No activity recorded yet",
            loadMore: "Load More",
            internal: "Internal",
            by: "by",
            systemUser: "System",
            types: {
                created: "Created",
                status_changed: "Status Changed",
                priority_changed: "Priority Changed",
                assigned: "Assigned",
                unassigned: "Unassigned",
                reply_added: "Reply Added",
                internal_note_added: "Internal Note Added",
                attachment_added: "Attachment Added",
                sla_breached: "SLA Breached",
                escalated: "Escalated",
                merged: "Merged",
                split: "Split",
                category_changed: "Category Changed",
                custom_field_updated: "Custom Field Updated",
            },
        },

        // Export
        export: {
            title: "Export Tickets",
            button: "Export",
            format: "Format",
            csv: "CSV",
            excel: "Excel",
            exporting: "Exporting...",
            success: "Tickets exported successfully",
            failed: "Failed to export tickets",
            noTickets: "No tickets to export",
            json: "JSON",
        },

        // Notification Preferences
        notifications: {
            title: "Notification Preferences",
            settings: "Notification Settings",
            loadError: "Failed to load notification preferences",
            saveSuccess: "Notification preferences saved successfully",
            saveError: "Failed to save notification preferences",
            resetSuccess: "Notification preferences reset to defaults",
            resetError: "Failed to reset notification preferences",
            enabledAll: "All notifications enabled",
            disabledAll: "All notifications disabled",
            toggleError: "Failed to toggle notifications",
            enableAll: "Enable All Email Notifications",
            emailNotifications: "Email Notifications",
            newTicket: "New Ticket",
            newTicketDesc: "Receive an email when a new ticket is created",
            ticketAssigned: "Ticket Assigned",
            ticketAssignedDesc: "Receive an email when a ticket is assigned to you",
            ticketReply: "Ticket Reply",
            ticketReplyDesc: "Receive an email when someone replies to your ticket",
            statusChange: "Status Change",
            statusChangeDesc: "Receive an email when ticket status changes",
            escalation: "Escalation",
            escalationDesc: "Receive an email when a ticket is escalated",
            slaWarning: "SLA Warning",
            slaWarningDesc: "Receive an email when a ticket is approaching SLA deadline",
            slaBreach: "SLA Breach",
            slaBreachDesc: "Receive an email when a ticket breaches SLA",
            emailDigest: "Email Digest",
            digestFrequencyLabel: "Digest Frequency",
            digestFrequencyDesc: "Receive a summary of ticket activity",
            digestFrequency: {
                none: "None",
                daily: "Daily",
                weekly: "Weekly",
            },
            inAppNotifications: "In-App Notifications",
            enableInApp: "Enable In-App Notifications",
            enableInAppDesc: "Show notifications within the application",
            resetDefaults: "Reset to Defaults",
            saveChanges: "Save Changes",
        },

        // Time formatting
        time: {
            justNow: "Just now",
            minutesAgo: "{count} minutes ago",
            hoursAgo: "{count} hours ago",
            daysAgo: "{count} days ago",
            weeksAgo: "{count} weeks ago",
            monthsAgo: "{count} months ago",
        },
    },
    models: {
        name: "Name",
        provider: "Provider",
        tier: "Tier",
        maxTokens: "Max Tokens",
        price: "Price",
        costoptimizedModels: "Cost-Optimized Models",
        costoptimizedModelsDes: "Smaller, faster models that cost less to run",
        flagshipModels: "Flagship Models",
        flagshipModelsDes: "Most versatile, high-intelligence flagship models",
        imageGeneration: "Image Generation",
        imageGenerationDes: "Models that generate images from text descriptions",
        reasoningModels: "Reasoning Models",
        reasoningModelsDes:
            "Advanced models that excel at complex, multi-step tasks",
        embeddingModels: "Embedding Models",
        embeddingModelsDes: "Models that convert text to vector embeddings",
        stt: "Speech-to-Text",
        sttDes: "Models that transcribe speech to text",
        tts: "Text-to-Speech",
        ttsDes: "Models that convert text to natural-sounding speech",
        visionModels: "Vision Models",
        visionModelsDes: "Models that can analyze and understand images",
        chatModels: "Chat Models",
        chatModelsDes: "General purpose conversational AI models",
        multimodalModels: "Multimodal Models",
        multimodalModelsDes: "Models that support multiple input/output types (text, image, audio, video)",
        moderationModels: "Moderation Models",
        moderationModelsDes: "Models that detect and filter harmful or inappropriate content",
        codeModels: "Code Models",
        codeModelsDes: "Models specialized in code generation, analysis, and completion",
        noRateLimitReceived: "No rate limit data received",
        loadingModels: "Loading models",
        featuredModels: "Featured Models",
        modelsFound: "models found",
        searchByModel: "Search models by name, provider, or capability...",
        searchByModelDes: "Most popular and recommended models",
        filterModels: "Filter Models",
        quickFilters: "Quick Filters",
        myAccessibleModels: "My Accessible Models",
        accessibleModelsDes: "Models I can access",
        visionModelsTxt: "Vision Models",
        visionModelsDes2: "Models with image capabilities",
        reasoningModelsTxt: "Reasoning Models",
        reasoningModelsDes2: "Advanced reasoning capabilities",
        costEffective: "Cost Effective",
        costEffectiveDes: "Budget-friendly options",
        providers: "Providers",
        selectProviders: "Select providers",
        capabilities: "Capabilities",
        selectCapabilities: "Select capabilities",
        accessTiers: "Access Tiers",
        selectTiers: "Select tiers",
        priceRange: "Price Range (per 1M tokens)",
        sortBy: "Sort By",
        onlyAccessible: "Only show accessible models",
        of: "of",
        models: "models",
        filter: "filter",
        filters: "filters",
        active: "active",
        showMore: "Show More",
        showLess: "Show Less",
        more: "more",
        applyFiltersClose: "Apply Filters & Close",
        providersPlaceholder: "Providers",
        capabilitiesPlaceholder: "Capabilities",
        tiersPlaceholder: "Tiers",
        categoryPlaceholder: "Category",
        allCategories: "All Categories",
        tierLabel: "Tier {0}",
        clearFilters: "Clear Filters",
        categoryModelsCount: "models",
        noModelsFound: "No models found",
        filtersActive: "filters active",
    },
    tooltip: {
        tpm: "Token per Minute Limit (TPM) based on the selected level",
        rpm: "Requests per Minute Limit (RPM) based on the selected level",
        negativeBalance: "Negative Balance",
        negativeBalanceExplanation:
            "Your account has a negative balance due to concurrent API requests. Please recharge your account.",
        negativeTotalBalance: "Negative Total Balance Details",
        currentBalance: "Current Balance",
        pendingCharges: "Pending Charges",
        rechargeAdvice:
            "Please recharge your account to continue using our services without interruption.",
        remainingIRT: "Remaining credit in Toman",
        remainingUNIT: "Remaining credit converted to units (Tether rate)",
        imagePricingAlert:
            "The cost calculation in image generation models is based on the model type, image size, quality, and the number of steps (if the model supports step adjustment). Therefore, the stated rate per image is considered an average rate. Except for the gpt-image-1 model, other models do not have an actual output token rate; this value is assigned only for system compatibility. For example, when calling the dall-e-3 model with HD quality and a size of 1024 by 1024, the token amount is considered to be 1000. At a rate of 40 units per one million tokens, this equals 0.04 units, which is the base output rate per image.",
        remainingInUNIT:
            "Total value of Toman credit converted to units plus credit converted to units. This amount represents the total value of the account's credit in units at the real-time conversion rate.",
        aboveTokensPricing:
            "When the total tokens exceed the specified amount, the rate is calculated based on this. In cases where the total tokens are below this amount, the base rate is used as the calculation basis. For more information, please refer to the provider’s documentation.",
        endpointMightNotAvailable:
            "Certain endpoints may not be available in AvalAI at this time. Please check the documentation for further details.",
        remainingCreditInIrtEquivalent:
            "The total balance of your wallet in Tomans. This balance includes the remaining Tomans plus the remaining ‘Units’ multiplied by the current exchange rate. Because credit packages are priced in Tomans, if your wallet balance contains currency in ‘Units’, its equivalent in Tomans is calculated based on the current exchange rate.",
    },
    limits: {
        selectModalities: "Modalities",
        selectEndpoints: "Endpoints",
        rateLimits: "Rate Limits",
        supported_endpoints: "Supported Endpoints",
        supports_parallel_function_calling: "Parallel Function Calling",
        supports_web_search: "Supports Web Search",
        max_images_per_prompt: "Max Images per Prompt",
        max_videos_per_prompt: "Max Videos per Prompt",
        max_video_length: "Max Videos Length",
        max_audio_length_hours: "Max Audio Hours",
        max_audio_per_prompt: "Max Audio per Prompt",
        max_pdf_size_mb: "Max PDF size (mb)",
        supported_modalities: "Supported Input Modialities",
        supported_output_modalities: "Supported Output Modialities",
        costPerOneMillionTokens: "Cost in UNIT per 1M tokens",
        details: "Details",
        name: "Model",
        max_tokens: "Max output Tokens",
        max_input_tokens: "Max Input Tokens",
        max_requests_per_1_minute: "RPM",
        max_tokens_per_1_minute: "TPM",
        pricing: {
            input_cost_per_token: "Input Cost per Token",
            output_cost_per_token: "Output Cost per Token",
            input_cost_per_page: "Input Cost per Page",
            input_cost_per_query: "Input Cost per Query",
            kTokens: "k Tokens",
            input: "Input Price",
            input_above: "Input Price Above",
            input_above_128k: "Input Price Above 128k Tokens",
            input_above_200k: "Input Price Above 200k Tokens",
            output: "Output Price",
            output_above: "Output Price Above",
            output_above_128k: "output Price Above 128k Tokens",
            output_above_200k: "output Price Above 200k Tokens",
            cached_input: "Cached Input Price",
            cache_creation_input: "Cached Creation Input Price",
            audio_input: "Audio Input Price",
            audio_output: "Audio Output Price",
            input_cost_per_character: "Cost per Character",
            input_cost_per_second: "Input Cost per Second",
            output_cost_per_second: "Output Cost per Second",
            audio_cached_input: "Audio Cached Input Price",
            output_cost_per_image: "Output Cost per Image",
            output_cost_per_video_per_second: "Output Cost per Second default size",
            output_cost_per_video_per_second_720x1280: "Output Cost per Second 720x1280",
            output_cost_per_video_per_second_1280x720: "Output Cost per Second 1280x720",
            output_cost_per_video_per_second_1024x1792: "Output Cost per Second 1024x1792",
            output_cost_per_video_per_second_1792x1024: "Output Cost per Second 1792x1024",
            source: "Source",
        },
        outputVideo: "Output Video",
        outputImage: "Output Image",
        perOneImage: "Per 1 Image",
        outputSeconds: "Output Seconds",
        perOneSecond: "Per 1 second",
        inputSeconds: "Input Seconds",
        perOneCharacterInput: "per 1 single character",
        characterInput: "Character Input",
        modelCapabilities: "Model Capabilities",
        maxTokens: "Maximum Tokens",
        maxInputTokens: "Maximum Input Tokens",
        maxOutputTokens: "Maximum Output Tokens",
        mode: "Mode",
        source: "Source",
        supportsSystemMessages: "System Messages",
        supportsFunctionCalling: "Function Calling",
        supportsVision: "Vision",
        supportsToolChoice: "Tool Choice",
        supportsResponseSchema: "Response Schema",
        supportsPromptCaching: "Prompt Caching",
        supportsReasoning: "Reasoning",
        howToUseApi1:
            "Get the models data via API",
        audioPerMinute: "Audio per Minute",
        imagesPerMinute: "Images per Minute",
        searchModel: "Search Model",
        selectOwner: "Select Owner",
        owner: "Owner",
        tier0: "Starter",
        tier1: "Level 1",
        tier2: "Level 2",
        tier3: "Level 3",
        tier4: "Level 4",
        tier5: "Level 5",
        audioInputTokens: "Audio Input Tokens",
        audioOutputTokens: "Audio Output Tokens",
        audioCachedInputTokens: "Audio Cached Input Tokens",
        minute: "minute",
        perMinute: "per minute",
        perOneMillionTokens: "per 1M tokens",
        currency: "Currency",
        costCalculator: "Cost Calculator",
        inputTokens: "Input Tokens",
        cachedInputTokens: "Cached Input Tokens",
        outputTokens: "Output Tokens",
        audioInputMinutes: "Audio Input Minutes",
        audioCachedInputMinutes: "Audio Cached Input Minutes",
        audioOutputMinutes: "Audio Output Minutes",
        estimatedCost: "Estimated Cost",
        tokenBasedPricing: "Token-based Pricing",
        audioBasedPricing: "Audio-based Pricing",
        modelDetails: "Model details",
        actions: "",
        providerType: "Provider Type",
        viewPricing: "View Pricing",
        pricingDetails: "Pricing Details",
        // Service Tier Pricing
        serviceTier: "Service Tier",
        serviceTiers: "Service Tiers",
        selectServiceTiers: "Service Tiers",
        serviceTierFilter: "Service Tier Filter",
        serviceTierPricing: "Service Tier Pricing",
        standardTier: "Standard",
        defaultTier: "Default",
        flexTier: "Flex",
        batchTier: "Batch",
        priorityTier: "Priority",
        defaultTierDescription: "Default pricing tier",
        standardTierDescription: "Default pricing tier",
        flexTierDescription: "Lower cost, variable latency",
        batchTierDescription: "Asynchronous processing",
        priorityTierDescription: "Higher availability",
        flexAvailable: "Flex Available",
        supportsFlexPricing: "Supports Flex Pricing",
        learnMoreAboutServiceTiers: "Learn more about service tiers",
        // Service Tier Explanation Modal
        serviceTierExplanation: {
            title: "Understanding Service Tiers",
            overview: "Service tiers allow you to optimize your API usage based on your specific needs. Different tiers offer various tradeoffs between cost, latency, and availability.",
            standardTitle: "Standard Tier",
            standardDescription: "The default service tier that provides consistent, predictable performance with standard pricing.",
            standardFeature1: "Predictable response times",
            standardFeature2: "Standard rate limits apply",
            standardFeature3: "Best for production workloads requiring consistent latency",
            flexTitle: "Flex Tier",
            flexDescription: "A cost-optimized tier that offers significant savings in exchange for variable latency. Perfect for non-time-sensitive workloads.",
            flexFeature1: "Up to 50% cost reduction compared to standard tier",
            flexFeature2: "Variable latency - responses may take longer during peak times",
            flexFeature3: "Ideal for batch processing, background tasks, or cost-sensitive applications",
            flexNote: "Flex tier requests are processed opportunistically when capacity is available. Response times may vary from seconds to minutes depending on demand.",
            howToUseTitle: "How to Use Service Tiers",
            howToUseDescription: "To use a specific service tier, include the 'service_tier' parameter in your API request:",
            supportedModelsTitle: "Supported Models",
            supportedModelsDescription: "Currently, only select OpenAI models support flex pricing. The list of supported models may expand over time.",
            modelAliases: "Model Aliases",
            pricingTitle: "Pricing Benefits",
            pricingDescription: "Flex tier pricing is typically 50% lower than standard tier pricing. The exact discount varies by model.",
            pricingExample: "Example: If standard input price is $2.00/1M tokens, flex price would be ~$1.00/1M tokens.",
            latencyTitle: "Latency Considerations",
            latencyDescription: "Standard tier provides consistent, low-latency responses ideal for real-time applications. Flex tier may have variable latency ranging from seconds to several minutes, making it best suited for asynchronous workloads where immediate response is not critical.",
            creditPackageWarningTitle: "Important: Credit Packages",
            creditPackageWarning: "Flex tier usage is NOT covered by credit packages! If you are using credit packages, API calls with service_tier == flex will be charged from your standard balance instead of your package credits.",
        },
        inputPrice: "Input Price",
        cachedInputPrice: "Cached Input Price",
        cacheCreationInputPrice: "Cache Creation Input Price",
        outputPrice: "Output Price",
        audioInputPrice: "Audio Input Price",
        audioOutputPrice: "Audio Output Price",
        noPricingAvailable: "No pricing information available",
        shortDesc1:
            "Check your API usage and understand the limits to ensure seamless integration.",
        title: "Access Limits",
        provider: "Provider",
        providerTooltip: "Some models may have different providers than their owner (e.g., deepseek.r1-v1:0 is owned by DeepSeek but provided by AWS Bedrock). Same models on different providers might also come with different pricing.",
        model: "Model",
        tpm: "Token per Minute Limit (TPM)",
        rpm: "Requests per Minute Limit (RPM)",
        info1:
            "Our API uses OpenAI’s standard rate limits: Tokens per Minute (TPM) and Requests per Minute/Day (RPM/RPD).",
        readDoc1: "For more details, Please read",
        readDoc2: "Access Level Guide",
        readDoc3: "provided by OpenAI.",
        usageTier: "Access Level",
        noAccess: "Free Access Level",
        free: "Starter",
        tier: "Level",
        completed: "Completed",
        current: "Current",
        upcoming: "Upcoming",
        toIncreaseTier: "To upgrade to the next access level",
        increaseYourLimits: "Upgrade Access Level",
        youCurrentTier: "Your account is at",
        ast: "",
        youWillmoveIf:
            "Your limits will automatically increase to the next usage level based on the following criteria. For more information, visit",
        toLearMore:
            "Learn more about the limitations associated with each usage level.",
        tiers: {
            zero: {
                monthlyLimit: "",
                p1: "Must verify a phone number.",
                p2: "0 UNIT / month usage limit.",
                p3: "",
                p4: "",
            },
            tier0: {
                monthlyLimit: "",
                p1: "Starter Plan for phone verified users.",
                p2: "5 UNIT / month.",
                p3: "",
                p4: "",
            },
            tier1: {
                p1: "At least 5 UNIT spent on the API since account creation.",
                monthlyLimit: "100 UNIT / month usage limit.",
                p3: "",
                p4: "",
            },
            tier2: {
                p1: "At least 50 UNIT spent on the API since account creation.",
                p2: "At least 7 days passed since first successful payment.",
                monthlyLimit: "500 UNIT / month usage limit.",
                p3: "",
                p4: "",
            },

            tier3: {
                p1: "At least 100 UNIT spent on the API since account creation.",
                p2: "At least 7 days passed since first successful payment.",
                monthlyLimit: "1000 UNIT / month usage limit.",
                p3: "",
                p4: "",
            },
            tier4: {
                p1: "At least 250 UNIT spent on the API since account creation.",
                p2: "At least 14 days passed since first successful payment.",
                monthlyLimit: "5,000 UNIT / month usage limit.",
                p3: "",
                p4: "",
            },
            tier5: {
                p1: "At least 1,000 UNIT spent on the API since account creation.",
                p2: "At least 30 days passed since first successful payment.",
                monthlyLimit: "10,000 UNIT / month usage limit.",
                p3: "",
                p4: "",
            },
        },
        // Tier Upgrade System Localizations
        upgradeTitle: "Upgrade Your Access Tier",
        maxTierTitle: "Maximum Tier Reached",
        upgradeDescription:
            "Increase your API access limits by upgrading to a higher tier. Higher tiers unlock more models, increased rate limits, and premium features.",
        maxTierDescription:
            "Congratulations! You've reached the highest access tier with maximum benefits and unlimited access to all features.",
        tierProgress: "Tier Progress",
        howItWorks: "How Tier Upgrades Work",
        importantNotes: "Important Information",
        currentTier: "Current Tier",
        nextTier: "Next Tier",
        progress: "Progress",
        totalPaid: "Total Paid",
        required: "Required",
        remaining: "Remaining",
        currentBenefits: "Current Benefits",
        nextTierBenefits: "Next Tier Benefits",
        upgradeNow: "Upgrade Now",
        maxTierReached: "Maximum Tier Achieved!",
        upgradeToNextTier: "Upgrade to Next Tier",
        unlockBenefits: "Unlock all premium benefits instantly",
        instantUpgrade: "Instant upgrade • No waiting time • Keep all credits",

        // Step-by-step process
        step1Title: "Top Up Your Account",
        step1Description:
            "Add credit to your account using IRT or UNIT. You can hold both currencies - the system doesn't automatically convert between them.",
        step2Title: "Automatic Tier Calculation",
        step2Description:
            "The system calculates your IRT payment's UNIT equivalent at payment time to track total paid. Your tier upgrades based on this total lifetime value in UNIT.",
        step3Title: "Enjoy Enhanced Limits",
        step3Description:
            "Access higher rate limits, more models, and premium features immediately after your tier upgrade.",
        step4Title: "Keep Your Credits",
        step4Description:
            "All your topped-up credits remain available for API usage. Tier upgrades don't consume your credits.",
        step5Title: "Permanent Benefits",
        step5Description:
            "Once upgraded, your tier benefits are permanent and will never be downgraded.",

        // Amount selection features
        selectAmount: "Select Amount to Top Up",
        suggestedAmount: "Suggested",
        suggestedAmountTooltip:
            "Recommended amount with 1% buffer to protect against exchange rate fluctuations",
        selectedAmount: "Selected Amount",
        minimumRequired: "Minimum required",
        exchangeRate: "Exchange rate",
        useSuggested: "Use Suggested",

        // Tier selection features
        selectTargetTier: "Choose Target Tier",
        selectTierPlaceholder: "Select tier to upgrade to",
        selectedTier: "Selected Tier",
        targetTierBenefits: "Target Tier Benefits",
        upgradeToSelectedTier: "Upgrade to Selected Tier",
        resetToNext: "Reset to Next",
        recommended: "Recommended",
        cost: "Cost",

        // Authentication and verification messages
        notLoggedIn: "Not Logged In",
        loginRequired: "Please log in to access tier benefits and upgrade options.",
        loginNow: "Log In",
        phoneNotVerified: "Phone Not Verified",
        phoneVerificationRequired:
            "Please verify your phone number to unlock tier benefits.",
        verifyPhone: "Verify Phone",
        notAuthenticated: "Authentication Required",
        authenticationRequired:
            "Please complete authentication to access your tier benefits.",
        authenticateNow: "Authenticate",
        accessRestricted: "Access Restricted",
        verificationRequired:
            "Please complete verification to access tier benefits.",
        getVerified: "Get Verified",

        // Important notes
        note1: "Tier upgrades are permanent and based on lifetime spending",
        note2: "All topped-up credits remain available for API usage",
        note3: "Higher tiers unlock access to more advanced AI models and features",

        // Tier Benefits
        benefits: {
            tier0: {
                basic: "Basic API access with starter limits",
                limited: "Access to essential models only",
            },
            tier1: {
                increased: "Increased rate limits and token capacity",
                priority: "Priority support and faster response times",
                models: "Access to additional AI models",
            },
            tier2: {
                higher: "Higher monthly usage limits (500 UNIT/month)",
                advanced: "Access to advanced reasoning models",
                support: "Enhanced customer support",
            },
            tier3: {
                premium: "Premium access with 1000 UNIT/month limit",
                enhanced: "Enhanced model selection and capabilities",
                features: "Access to beta features and new releases",
            },
            tier4: {
                enterprise: "Enterprise-level access (5000 UNIT/month)",
                maximum: "Maximum rate limits and priority processing",
                dedicated: "Dedicated support and custom configurations",
            },
            tier5: {
                unlimited: "Unlimited access to all features and models",
                all: "Access to all current and future AI models",
                priority: "Highest priority support and custom solutions",
            },
        },
    },
    usage: {
        totalUsed: "Total Used",
        totalAudio: "Total Audio",
        audioInputSeconds: "Audio Input(s)",
        audioOutputSeconds: "Audio Output(s)",
        all: "All",
        success: "Success",
        pending: "Pending",
        failed: "Failed",
        summary: "Summary",
        download: "Download",
        action: "Action",
        status: "Status",
        expiresAt: "Expires Date",
        generatedAt: "Generated Date",
        consumptionReport: "API Consumption Report",
        generateReport: "Generate Report",
        timeFrame: "Time Frame",
        meanExchangeRate: "Mean Exchange Rate",
        inputTokens: "Input Tokens",
        outputTokens: "Output Tokens",
        cachedTokens: "Cached Tokens",
        request: "Request",
        totalTokens: "Total tokens",
        totalRequests: "Total requests",
        costs: "Costs",
        cost: "Cost",
        tokens: "Tokens",
        requests: "Requests",
        title: "Usage",
        daily: "Daily",
        hourly: "Hourly",
    },
    feedback: {
        sendFeedback: "Submit Feedback",
        description: "Share your thoughts with us",
        title: "Title",
        titleInputPlaceHolder: "What's on your mind?",
        body: "Feedback",
        bodyInputPlaceHolder: "Your feedback, anything you want to share with us.",
        footerDescription:
            "Providing feedback can help us improve our system and enhance the user experience for everyone.",
        sendButton: "Send",
        thankYouTitle: "Thank You!",
        thankYouMessage:
            "We got your feedback. It usually takes two days for us to get back with an answer but sometimes sooner.",
        okayButton: "Okay",
        sendFailed: "Sending Feedback failed",
        sendSuccess: "Feedback sent",
        bodyCantBeEmpty: "Feedback can't be empty",
        bodyTooShort: "Feedback is too short",
    },
    languages: {
        "fa-IR": "Persian",
        "en-US": "English",
        // Add other languages as needed
    },
    paymentStatus: {
        success: "Success",
        pending: "Pending",
        failed: "Failed",
        processing: "Processing",
    },
    status: {
        pending: "Pending",
        completed: "Completed",
        failed: "Failed",
    },
    reports: {
        longerFramesRateLimit: "For reports with a timeframe exceeding 3 days, only one request is permitted every 24 hours.",
        reportGenerationSubmitted: "Report submited successfuly, please the report status below, Some reports can take up to 60 minutes",
        title: "API Consumption Reports",
        timeFrame: "Time Frame",
        generateReport: "Generate Report",
        reportSummary: "Report Summary",
        downloadReport: "Download",
        viewSummary: "Summary",
        lastHour: "Last hour",
        last6Hours: "Last 6 hours",
        last12Hours: "Last 12 hours",
        lastDay: "Last 24 hours",
        last2Days: "Last 48 hours",
        last3Days: "Last 72 hours",
        lastWeek: "Last week",
        last28Days: "Last 28 days",
        lastMonth: "Last month",
        last3Months: "Last 3 months",
        last6Months: "Last 6 months",
        lastYear: "Last year",
        allTime: "All time",
        columns: {
            language: "Language",
            generatedAt: "Generated At",
            timeFrame: "Time Frame",
            expiresAt: "Expires At",
            status: "Status",
        },
        summary: {
            user: "User",
            dateRange: "Date Range",
            generatedAt: "Generated At",
            totalTransactions: "Total Transactions",
            totalCostUnits: "Total Cost Units",
            totalPaidUnits: "Total Paid Units",
            totalPaidIRT: "Total Paid IRT",
            totalPaidGrantIRT: "Total Paid Grant IRT",
            financialDetails: "Costs overview",
        },
    },
    billing: {
        noCreditPackages: "No Credit Package!",
        manageCreditPackages: "Manage Credit Packages",
        packagesTotalUnit: "Total value in UNIT",
        expirationTimeline: "Expiration Timeline",
        creditBreakdown: "Credit Packages",
        unnamedPackage: "Credit Package",
        sortOptions: {
            featured: "Featured",
            price: "Price (Low to High)",
            valueRatio: "Value Ratio",
            newest: "Newest",
            oldest: "Oldest",
            expiration: "Expiration Time",
        },
        packages: {
            myPackages: "My Packages",
            promotional: "Promotional",
            summary: {
                total: "Total Packages",
                active: "Active Packages",
                usage: "Average Usage",
                remaining: "Total Remaining",
                totalSources: "Total Sources",
                packages: "Credit Packages",
                grants: "Grants",
                totalBalance: "Total Balance",
            },
            tabs: {
                overview: "Overview",
                usage: "Usage Analytics",
                expiration: "Expiration Timeline",
            },
            otp: {
                title: "Verify Your {amount} Purchase",
                description:
                    "Please enter the 6-digit verification code sent to your phone to complete your purchase.",
                invalidLength: "Invalid OTP length",
                send: "Send Code",
                resent: "OTP resent successfully",
                expiresIn: "Code expires in {time}",
                expired: "Verification code has expired",
                cancel: "Cancel",
                verify: "Verify Code",
                resend: "Send New Code",
            },
            timeline: {
                expired: "Expired",
                thisMonth: "This Month",
                nextMonth: "Next Month",
                noExpiration: "No packages have expiration dates",
                expiredCount: "Expired packages",
                expiringThisWeek: "Expiring this week",
                expiringThisMonth: "Expiring this month",
                safePeriod: "Safe period (30+ days)",
                summary: "Summary",
                later: "Later",
                remaining: "Remaining",
            },
            filters: {
                title: "Filters",
                reset: "Reset Filters",
                allServices: "All Services",
                serviceType: "Service Type",
                apiOnly: "API Only",
                subscriptionOnly: "Subscription Only",
                showPromotional: "Show Promotional Packages",
                priceRange: "Price Range",
                subServices: "Sub Services",
                modelFamilies: "Model Families",
                subscriptionTiers: "Subscription Tiers",
            },
            authRequired: {
                title: "Authentication Required",
                description:
                    "Please log in to view your purchased packages and track their usage.",
            },
            paymentMethods: {
                bankCard: "Bank Card",
                creditBalance: "Credit Balance",
            },
            status: {
                all: "All",
                active: "Active",
                expired: "Expired",
                exhausted: "Exhausted",
            },
            totalAmountBePaid: "Total Amount to Pay",
            totalCreditsReceiving: "Total Credits Receiving",
            empty: "No packages available",
            emptyDescription:
                "There are currently no credit packages available for purchase",
            allServices: "All Services",
            noExpiration: "No Expiration",
            creditPackages: "Credit Packages",
            grantCredits: "Grant Credits",
            generalBalance: "General Balance",
            generalBalanceDescription: "Your main wallet balance for all services",
            creditsPerToman: "more credits",
            expired: "Expired",
            expirestoday: "Expires Today",
            expiresTomorrow: "Expires Tomorrow",
            expiresInDays: "Expires in {days} days",
            expiresInWeeks: "Expires in {weeks} weeks",
            expiresOn: " on {date}",
            redirectingToPayment: "Redirecting to payment gateway",
            purchaseComplete: "Purchase completed successfully",
            purchaseSuccessMessage:
                "Your credit package has been purchased and added to your account. You can now view and manage it in your packages section.",
            goToMyPackages: "Go to My Packages",
            purchaseFailed: "Purchase failed. Please try again.",
            insufficientCredit: "Insufficient Credit Balance",
            insufficientCreditMessage:
                "You don't have enough credit balance to complete this purchase. You need {shortfall} more.",
            choosePaymentOption: "Choose a payment option:",
            useDirectPayment: "Use Direct Card Payment",
            topUpCredit: "Top Up Credit Balance",
            otpFailed: "OTP verification failed",
            paymentCheckFailed: "Failed to check payment status. Please try again.",
            openPaymentPage: "Open Payment Page",
            paymentPending:
                "Your payment is still pending. Please complete the payment or try again later.",
            paymentNotFound: "Transaction not found. Please try the purchase again.",
            clearFilters: "Clear Filters",
            browse: "Browse Packages",
            title: "Credit Packages",
            description:
                "Purchase credit packages to access our AI services and manage your account balance.",
            marketplace: "Marketplace",
            purchaseTitle: "Purchase Package",
            quantity: "Quantity",
            packages: "packages",
            paymentMethod: "Payment Method",
            unitPrice: "Unit Price",
            toman: "Toman",
            totalAmount: "Total Amount",
            totalCredits: "Total Credits",
            cancel: "Cancel",
            confirmPurchase: "Confirm Purchase",
            processingPayment: "Processing Payment...",
            noPackagesFound: "No packages found",
            purchasedOn: "Purchased on {date}",
            usage: "Usage",
            remaining: "Remaining",
            used: "Used",
            viewDetails: "View Details",
            viewDetailsTooltip: "Click to view detailed usage statistics",
            featured: "Featured",
            apiService: "API Service",
            subscriptionService: "Subscription Service",
            scope: "Scope",
            validFor: "Valid for {days} days",
            maxPerUser: "Max {count} per user",
            unavailable: "Unavailable",
            purchase: "Purchase",
            browsePackages: "Browse Packages",
            noPackages: "No packages found",
            package: "Package",
            availableModels: "Available Models",
            balance: "Balance",
            grant: "Grant",
            maxQuantity: "Max Available Quantity",
            packageScope: "Package Scope",
            valueRatioTooltip:
                "You'll get more credit to spend compared the amount you pay for",
            packageScopeTooltip:
                "The list of authorized services covered by the credit package may include specific models or services. This package is exclusively designed for use within the scope of authorized coverage as detailed in the package description. By purchasing this package, you will not be able to benefit from discounts on other models or services not covered by the package. If you use services that are not included in the coverage, charges will be calculated at standard rates",
            agreements: {
                title: "Purchase Agreement",
                description: "Please read and accept the following terms before proceeding with your purchase:",
                balanceRequirement: "To utilize credit packages effectively, your general account balance must maintain a positive value. API services will be automatically deactivated if the general balance reaches zero or becomes negative. We recommend maintaining a minimum balance of 0.5 UNIT (or equivalent) to ensure uninterrupted service.",
                expirationPolicy: "Credit packages include a fixed expiration date that cannot be extended under any circumstances. Once expired, packages cannot be renewed or restored, regardless of remaining unused credits.",
                serviceCoverage: "Each credit package applies exclusively to the services and models specified in its description. Credits cannot be transferred or applied to other services, models, or features not explicitly included in the package terms.",
                acceptTerms: "I have read and accept all terms and conditions above",
                mustAcceptTerms: "You must accept the terms and conditions to proceed with the purchase.",
                balanceRequirementTitle: "Account Balance Requirement",
                expirationPolicyTitle: "Package Expiration Policy",
                serviceCoverageTitle: "Service Coverage Limitation",
                serviceTierLimitationTitle: "Service Tier Limitation",
                serviceTierLimitation: "Credit packages only cover API requests made with the default 'standard' service tier. If you use the 'flex' service tier (by setting service_tier=\"flex\" in your API requests), those costs will NOT be deducted from your package credits and will instead be charged to your standard account balance.",
            },
        },
        notificationWillBe: "Notifications will be sent to",
        thresholdsMustBeDivisibleByFive: "Thresholds must be divisible by 5",
        thresholdsMustBeLeast: "Thresholds must be at least ",
        creditNotificationSaved: "Notification settings saved successfully",
        additionalRecipientsDescription:
            "Notifications are sent to the email address and phone number registered in your account. However, if you need notifications to be sent to additional phone numbers or email addresses, you can add them below.",
        addUpToTwoEmailsAndPhones:
            "Add up to 2 additional email addresses and phone numbers",
        additionalRecipients: "Additional Recipients",
        notificationThresholds: "Notification Thresholds",
        receiveAlertsWhen:
            "Receive alerts when your credit balance reaches specified thresholds",
        creditNotificationSettings: "Credit Notification Settings",
        packageBalanceWarning: {
            title: "Credit Package Balance Warning",
            message: "You have active credit packages, but your general account balance is zero or negative. API services will be automatically deactivated until you recharge your account.",
            requirement: "A positive general balance is required to use credit packages and keep your API keys active.",
            action: "Recharge your account now to reactivate your API services.",
            rechargeButton: "Recharge Account"
        },
        loadingCreditNotificationSettings: "Loading your notification settings",
        creditNotificationDisabled: "Credit notifications are currently disabled",
        creditNotificationAt: "Notifications enabled at these thresholds",
        creditNotification: "Credit Notifications",
        rateExpired: "Exchange Rate Expired",
        clickRefreshToUpdate: "Click refresh to update rates",
        refreshRate: "Refresh Rate",
        amountMustBePositive: "Exchange amounts must be greater than zero",
        invalidExchangeAmount: "Invalid exchange amount. Please check your input.",
        invalidExchangeParameters: "Invalid exchange parameters",
        exchangeReviewFailed: "Failed to review exchange. Please try again.",
        error: "Error",
        exchangeSuccessful: "Exchange completed successfully",
        exchangeFailedUnknown: "Exchange failed for unknown reason",
        exchangeValidationFailed: "Exchange validation failed",
        unauthorizedExchange: "Unauthorized to perform exchange",
        tooManyRequests: "Too many requests, please try again later",
        tooManyRequestsDesc: "",
        exchangeFailed: "Failed to complete exchange",
        refreshDataFailed: "Failed to refresh data",
        totalPaidInUnitTooltip:
            "Shows the total amount of credits (in UNIT) added to this account since creation. Each top-up is calculated using the exchange rate that was active at the time of purchase, not the current rate.",
        totalPaidInUnit: "Total Paid In Unit",
        historyAmount: "Amount",
        paymentId: "Id",
        trackingCode: "Tracking Code",
        paymentStatusFailed: "Failed to recheck payment status",
        paymentStatusUpdated: "Payment status updated",
        totalAmount: "Total Amount",
        pendingTransactions: "Pending Transactions",
        confirmedTransactions: "Confirmed Transactions",
        selectStatus: "Select Status",
        selectItemType: "Select Item Type",
        paymentHistory: "Payment History",
        totalTransactions: "Total Transactions",
        purchaseItem: "Type",
        subscription: "Subscription",
        credit: "Credit",
        confirmationDate: "Confirmation Date",
        paidAmount: "Paid Amount",
        discount: "Discount",
        howToUseApi1:
            "Get the remaining credit via API",
        sampleOutput: "Sample response:",
        howToUseApi2:
            "Explanation: 'remaining_irt' is equivalent to 'remaining credit in Toman', 'remaining_unit' is equivalent to 'remaining credit converted to units (Tether rate)', 'exchange_rate' is the real-time conversion rate, and finally 'total_unit' is equivalent to all credits including those increased through bank payments, gift credits, grants, etc., based on the real-time conversion rate.",
        exhausted: "exhausted",
        remainingDays: "remaining days",
        remainingHours: "remaining hours",
        remainingMinutes: "remaining minutes",
        remaining: "Remaining",
        expiration: "Expiration",
        grantsTotalUnit: "Total value in UNIT",
        unnamedGrant: "Unnamed",
        grants: "Grants",
        exchangeRateUSDT: "USDT Rate",
        fee: "Fees",
        timesUp: "Transaction invalidated",
        reviewValidTill: "Details invalidated in ",
        secondsValidAst: "seconds.",
        exchangeTo: "Exchange to",
        exchangeFrom: "Exchange from",
        exchangeRate: "Exchange rate",
        feeAmount: "Fees",
        shortDesc1:
            "Manage your billing information, view invoices, and update payment methods.",
        title: "Billing",
        topup: "TopUp",
        minAmount: "Minimum of 50,000",
        IRI: "IRR",
        IRT: "IRT",
        UNIT: "UNIT",
        total: "Total",
        recharge: "Recharge",
        confirm: "Confirm",
        and: "",
        pay: "Pay",
        remaningCredit: "Remaining Credit",
        remainingCredit: "Remaining Credit",
        remainingCreditTotalUnit: "Total Remaining Credit in UNIT",
        zero: "0",
        noCredits: "No Credit left",
        sourceAmount: "Exchange",
        targetAmount: "To",
        amount: "",
        exchange: "Exchange",
        exchangeTitle: "Currency Exchange",
        confirmAndExchange: "Confirm & Exchnage",
        close: "close",
        exchangeConfirmFailed: "Exchange failed.",
        exchangeConfirmed: "Exchange confirmed.",
        totalCost: "Total Cost",
        loginToViewCredit:
            "Login to view your actual credit balance and transaction history",
    },
    affiliate: {
        stepsTitle: "Start Your Affiliate Journey",
        stepsDescription: "Follow these simple steps to start earning rewards",
        step1Title: "Get Your Invite Code",
        step1Description: "Your personal invite code is ready to share",
        step1Description2: "Sign In to Get Your Code",
        step2Title: "Invite Friends",
        step2Description: "Share your invite code with friends and colleagues",
        step2Description2:
            "When they sign up using your code, both of you get benefits!",
        step3Title: "Earn Rewards",
        step3Description:
            "Earn commission for every transaction your invitees make",
        step3Description2: "Track your earnings right here on this page!",
        title: "Affiliate Marketing",
        descriptionLg:
            "Join our affiliate program and promote AvalAI to your network using the link below. Earn a share of the sales revenue and boost your income.",
        descriptionXs:
            'Earn 10% commission on "Plus" subscription sales for one year from the date of your referral!',
        totalUsers: "Total Referrals",
        usersAddedThisMonth: "Referrals This Month",
        totalIncomeThisMonth: "Earnings This Month",
        totalIncomeConfirmed: "Total Earnings",
        totalIncomePending: "Pending Earnings",
        inWithdrawalProcess: "Withdrawal in Process",
        lastSettledIncome: "Last Withdrawal",
        usersInMonth: "Monthly Referrals",
        username: "Username",
        registrationDate: "Registration Date",
        lastTransactionDate: "Last Transaction",
        confirmedCommission: "Confirmed Commission",
        pendingCommission: "Pending Commission",
        netIncome: "Net Income",
        transactions: "Transactions",
        noTransaction: "No Transactions",
    },
    api: {
        couldNotFetchShowingCatched: "Could not fetch latest key data. Showing cached data.",
        loadingKeyData: "Loading the API key settings",
        keyNotFound: "API key not found, Please try refresh the page if you believe there's an error.",
        maxApiKeysReached:
            "Max API keys reached, Please remove some keys before creating a new one.",
        endpointAccess: "Endpoint Access",
        allowedEndpoints: "Allowed Endpoints",
        allowedIntents: "Allowed Intents",
        allEndpointsAllowed: "All endpoints allowed",
        allIntentsAllowed: "All intents allowed",
        noEndpointsAvailable: "No endpoints available",
        noIntentsAvailable: "No intents available",
        ipFormatHelp:
            "Supported formats: IPv4 (e.g., 192.168.1.1), IPv6, and CIDR notation (e.g., 192.168.1.0/24)",
        invalidCIDRFormat: "Invalid CIDR format",
        invalidCIDRRange: "Invalid CIDR range (0-128)",
        invalidIPv4CIDRRange: "Invalid IPv4 CIDR range (0-32)",
        invalidIPv4Address: "Invalid IPv4 address",
        invalidIPv6Address: "Invalid IPv6 address",
        ipExamples: "Examples",
        max256IpsWarning: "Maximum 256 IPs allowed. Some IPs were not imported.",
        noUsage: "None",
        budgetUsed: "Usage",
        keyModified: "Key modified successfully",
        apiV4RangeNumebrs: "IPv4 address numbers must be between 0 and 255",
        noModelsAvailable: "No models available",
        allModelsAllowed: "All models allowed",
        allowedModels: "Allowed Models",
        forever: "Forever",
        keyExpirationDay: "Time To Live (days)",
        iPRestrictions: "IP Restrictions",
        pleaseEnterValidIp: "Please enter a valid IPv4 or IPv6 address",
        neverExpires: "Never expires",
        keyExpiration: "Key Expiration",
        totalBudget: "Total Budget",
        noLimit: "No limit",
        monthlyBudget: "Monthly Budget",
        usageLimits: "Usage Limits",
        ipAddressInfoFooter:
            "Leave empty to allow all IPs. Enter IPv4 or IPv6 addresses or CIDR.",
        enterIpAddress: "Enter IP address",
        uploadIpTips: "Upload .txt or .csv",
        importIPs: "Import IPs",
        securitySettings: "Security Settings",
        advancedSettings: "Advanced Settings",
        deleteAllIps: "Delete All IPs",
        shortDesc1:
            "Securely manage your API keys to authenticate and interact with our APIs.",
        noName: "No name",
        showOnce: "Secret key showing once, Please save it somewhere safe.",
        close: "close",
        api: "API",
        confirmRevoke: "Are you sure to revoke the API key?",
        guardrail: {
            title: "Guardrail Settings",
            description: "Protect your API calls with guardrails",
            enabled: "Guardrails Enabled",
            disabled: "Guardrails Disabled",
            explanation: "Guardrail Explanation",
            explanationTitle: "How Guardrails Work",
            explanationContent:
                "Guardrails help protect your API calls by detecting and redacting sensitive information like API keys and tokens. When enabled, all API calls are processed through the detect-secrets system before reaching the LLM models, with sensitive data replaced by [REDACTED].",

            // Modal section titles
            currentImplementation: "Current Implementation",
            performanceImpact: "Performance Impact",
            howActivated: "How Guardrails Are Activated",
            recommendation: "Our Recommendation",
            futureDevelopment: "Future Development",
            securityNotice: "Security Notice",

            // Recommendation section
            recommended: "Recommended",
            recommendationDesc:
                "We strongly recommend enabling guardrails for enhanced security. While it adds some latency, the protection it provides is valuable for most use cases. However, if your application requires minimal latency and you're confident in your data handling, you can disable this feature.",

            // Performance impact section
            latencyImpact:
                "Enabling guardrails adds a preprocessing step that increases request latency by approximately 200ms to 3000ms depending on the size and complexity of your input data.",
            latencyTooltip:
                "Latency impact varies based on request size and complexity",
            disableForLowLatency:
                "If your application requires minimal latency and you're confident no sensitive data is being sent, you may choose to disable this feature to reduce overhead.",

            // Current implementation section
            detectSecrets: "detect-secrets",
            implementationDetails:
                'Currently, our guardrail system implements <strong>{0}</strong>, which uses the <a href="{1}" target="_blank" rel="noopener">Yelp/detect-secrets</a> open-source project to detect and clean sensitive data such as API keys and tokens in your API calls.',
            redactionProcess:
                "When the guardrail detects sensitive information, it automatically replaces it with <code>[REDACTED]</code> before the request reaches the LLM models. This process leaves no logs of the sensitive data being cleaned, providing an additional layer of security.",

            // Activation methods section
            userLevelTitle: "User-level activation",
            userLevelDesc:
                "When enabled in your user settings, all API calls are automatically scanned and protected",
            perRequestTitle: "Per-request activation",
            perRequestDesc:
                'You can include <code>guardrails: ["hide-secrets"]</code> in your API request data to activate guardrails for that specific call, even if disabled at the user level',

            // Future development section
            futureDesc:
                "Currently, users cannot define custom guardrails, but we plan to enhance this system with more advanced security measures and customization options in future updates.",

            // Security notice section
            securityDesc:
                "While our guardrail system provides an additional layer of security, it is not guaranteed to detect all sensitive information. The effectiveness depends on the underlying detect-secrets project. We recommend following security best practices and avoiding sending sensitive information in your API calls whenever possible.",
        },
        removeConfirmYes: "Confirm & revoke",
        removeConfirmNo: "Cancel",
        remove: "Revoke",
        edit: "Edit",
        update: "Update",
        editSecretKey: "Edit secret key",
        editingSecretKey: "Editing secret key",
        cancel: "Cancel",
        createNewSecret: "Create secret key",
        cName: "Name",
        cSecret: "Secret Key",
        cCreated: "Created",
        cLastUsed: "Last used",
        cActions: "Actions",
        title: "API Keys",
        editKey: "Edit Secret Key",
        createKey: "Create new key",
        keyName: "Name",
        keyNamePlaceholder: "My Test Key",
        createNewKey: "Create secret key",
        maskedKeysShown: "Your API keys are listed below.",
        howToUse1:
            'To use your keys, set base_url="https://api.avalai.ir/v1" in OpenAI SDK.',
        howToUse2: "this post",
        konid: "",
        info2:
            "Do not share your API key with others, or expose it in the browser or other client-side code.  Please note that we do not display your secret API keys again after you generate them.",
        howToUse3:
            "Use official OpenAI libraries/frameworks, or ensure your HTTP requests follow OpenAI's standard structure to access all services.",
        propagatingKey: "Propagating API Key",
        propagationMessage: "Your API key is being securely propagated to our infrastructure. This usually takes about 30 seconds.",
        propagationStatus: "Syncing across regions...",
    },
    summary: {
        requests: "Requests",
        noUsageDataTooltip:
            "No usage data available. Once data is recorded, it will appear here",
        remainingCredit: "Remaining Credit",
        totalTokens: "Total Tokens",
        totalRequests: "Total Requests",
        remainingCreditUnit: "Remaining (UNIT)",
        remainingCreditIrt: "Remaining (IRT)",
        usageTrends: "Usage Trends",
        last7Days: "Last 7 Days",
        last28Days: "Last 28 Days",
        modelTokenDistribution: "Model Token Distribution",
        dailyRequests: "Daily Requests",
        topModelsUsage: "Top Models Usage",
        hourlyUsageTokens: "Hourly Token Usage",
        hourlyUsageRequests: "Hourly Requests",
        period1Hour: "Last Hour",
        period6Hours: "Last 6 Hours",
        period12Hours: "Last 12 Hours",
        period24Hours: "Last 24 Hours",
        cost: "Cost",
        inputTokens: "Input Tokens",
        outputTokens: "Output Tokens",
        activeGrants: "Active Grants",
        expiresIn: "Expires In",
        days: "Days",
        recentTransactions: "Recent Transactions",
        currency: "Currency",
        modelTokenUsage: "Model Token Usage",
        last1Hour: "Last 1 Hour",
        last6Hours: "Last 6 Hours",
        last12Hours: "Last 12 Hours",
        last24Hours: "Last 24 Hours",
        dailyTrendNotAvailable:
            "Detailed daily trend view is available for 7-day and 28-day periods.",
        totalCost: "Total Cost",
    },
    error: {
        fetchFailed: "Fetch data failed",
    },
    system: {
        title: "AvalAI",
    },
    common: {
        to: "To",
        input: "Input",
        output: "Output",
        remainingTime: "Remaining Time",
        at: "at",
        allTiers: "All Tiers",
        allModels: "All Models",
        outof: "Out of",
        days: "Days",
        hours: "Hours",
        minutes: "Minutes",
        moreItems: "more",
        tiers: "Tiers",
        models: "Models",
        discountOff: "off",
        discount: "discount",
        fetchFailed: "Fetch data failed",
        sort: "Sort",
        tier: "level",
        copy: "Copy",
        projectUpdates: "Project Updates",
        viewAll: "View All",
        readMore: "Read More",
        loadMore: "Load More",
        noResults: "No Results Found",
        resultsFoundInOtherTabs: "Results Found in Other Tabs",
        noResultsInCurrentTab: "No Result found in This Tab",
        and: "and",
        additionalPersianOnly: "",
        additionalEnglishOnly: "additional",
        additional: "additional",
        emailAddress: "email address",
        phoneNumber: "phone number",
        fetchError: "Failed to fetch data",
        tier1AndAbove: "Tier 1 or above",
        tier3AndAvove: "Tier 3 or above",
        tier5Only: "Tier 5",
        requiresTier1: "This feature requires Tier 1 or above",
        requiresTier3: "Custom thresholds require Tier 3 or above",
        requiresTier5: "Additional recipients require Tier 5",
        fixErrorsBeforeSaving: "Please fix the form errors before saving",
        failedToSaveSettingsTryAgain: "Failed to save settings. Please try again.",
        equivalent: "Equivalent",
        manage: "Manage",
        threshold: "Threshold",
        saveChanges: "Save Changes",
        saving: "Saving",
        phone: "phone",
        email: "Email",
        recipients: "Recipients",
        thresholds: "thresholds",
        custom: "Custom",
        default: "Default",
        retry: "Retry",
        pageLoading: "Loading page...",
        pageLoadError: "Failed to load page",
        pageLoadErrorDesc: "An error occurred while loading this page. Please try again.",
        useInApi: "Use in API",
        seconds: "Seconds",
        docs: "Documentation",
        learnMore: "Learn More",
        save: "Save",
        select: "Select",
        comingSoon: "Coming Soon",
        attach: "Attach",
        back: "Back",
        clickToCopy: "Click to copy",
        disabled: "Disabled",
        enabled: "Enabled",
        hide: "Hide",
        configure: "Configure",
        show: "Show",
        systemStatus: "System Status",
        page: "page",
        total: "total",
        showLess: "Show Less",
        showMore: "Show More",
        downloadError: "Dowload failed, please try again.",
        downloadSuccess: "Download Succeeded",
        downloadCSV: "Download CSV",
        downloadExcel: "Download Excel",
        download: "Download",
        api: "API",
        credit: "Credit",
        subscription: "Subscription",
        recheck: "Recheck",
        nothingFound: "Nothing found",
        time: "Time",
        date: "Date",
        somethingWentWrongRefreshPage: "Something went wrong, Please retry again",
        shortCuts: "Quick Access",
        phoneAlreadyVerified:
            "Phone number verified successfully, refreshing in a moment...",
        phoneVerificationRequired:
            "A verified phone number required, Please enter your phone number.",
        backToChat: "Back to Chat",
        copied: "Copied",
        copyFailed: "Something went wrong",
        optional: "optional",
        action: "Action",
        add: "Add",
        addSuccess: "Add Success",
        backToHome: "Back to home",
        batchDelete: "Batch Delete",
        cancel: "Cancel",
        close: "Close",
        check: "Check",
        columnSetting: "Column Setting",
        config: "Config",
        confirm: "Confirm",
        delete: "Delete",
        deleteSuccess: "Delete Success",
        confirmDelete: "Are you sure you want to delete?",
        edit: "Edit",
        index: "Index",
        keywordSearch: "Please enter keyword",
        logout: "Logout",
        logoutConfirm: "Are you sure you want to log out?",
        lookForward: "Coming soon",
        modify: "Modify",
        modifySuccess: "Modify Success",
        noData: "No Data",
        operate: "Operate",
        pleaseCheckValue: "Please check whether the value is valid",
        refresh: "Refresh",
        reset: "Reset",
        search: "Search",
        switch: "Switch",
        tip: "Tip",
        trigger: "Trigger",
        update: "Update",
        updateSuccess: "Update Success",
        userCenter: "User Center",
        yesOrNo: {
            yes: "Yes",
            no: "No",
        },
        newsCategories: {
            announcement: "Announcement",
            api: "API",
            models: "Models",
            performance: "Performance",
            billing: "Billing",
            security: "Security",
            feature: "Feature",
            documentation: "Documentation",
            tutorial: "Tutorial",
            release: "Release",
        },
        noUpdates: "No updates available",
    },
    request: {
        logout: "Logout user after request failed",
        logoutMsg: "User status is invalid, please log in again",
        logoutWithModal: "Pop up modal after request failed and then log out user",
        logoutWithModalMsg: "User status is invalid, please log in again",
        refreshToken: "The requested token has expired, refresh the token",
        tokenExpired: "The requested token has expired",
    },
    theme: {
        themeSchema: {
            title: "Theme Schema",
            light: "Light",
            dark: "Dark",
            auto: "Follow System",
        },
        layoutMode: {
            title: "Layout Mode",
            vertical: "Vertical Menu Mode",
            horizontal: "Horizontal Menu Mode",
            "vertical-mix": "Vertical Mix Menu Mode",
            "horizontal-mix": "Horizontal Mix menu Mode",
        },
        themeColor: {
            title: "Theme Color",
            primary: "Primary",
            info: "Info",
            success: "Success",
            warning: "Warning",
            error: "Error",
            followPrimary: "Follow Primary",
        },
        scrollMode: {
            title: "Scroll Mode",
            wrapper: "Wrapper",
            content: "Content",
        },
        page: {
            animate: "Page Animate",
            mode: {
                title: "Page Animate Mode",
                fade: "Fade",
                "fade-slide": "Slide",
                "fade-bottom": "Fade Zoom",
                "fade-scale": "Fade Scale",
                "zoom-fade": "Zoom Fade",
                "zoom-out": "Zoom Out",
                none: "None",
            },
        },
        fixedHeaderAndTab: "Fixed Header And Tab",
        header: {
            height: "Header Height",
            breadcrumb: {
                visible: "Breadcrumb Visible",
                showIcon: "Breadcrumb Icon Visible",
            },
        },
        tab: {
            visible: "Tab Visible",
            cache: "Tab Cache",
            height: "Tab Height",
            mode: {
                title: "Tab Mode",
                chrome: "Chrome",
                button: "Button",
            },
        },
        sider: {
            inverted: "Dark Sider",
            width: "Sider Width",
            collapsedWidth: "Sider Collapsed Width",
            mixWidth: "Mix Sider Width",
            mixCollapsedWidth: "Mix Sider Collapse Width",
            mixChildMenuWidth: "Mix Child Menu Width",
        },
        footer: {
            visible: "Footer Visible",
            fixed: "Fixed Footer",
            height: "Footer Height",
            right: "Right Footer",
        },
        themeDrawerTitle: "Theme Configuration",
        pageFunTitle: "Page Function",
        configOperation: {
            copyConfig: "Copy Config",
            copySuccessMsg:
                'Copy Success, Please replace the variable "themeSettings" in "src/theme/settings.ts"',
            resetConfig: "Reset Config",
            resetSuccessMsg: "Reset Success",
        },
    },

    route: {
        // "support_knowledge-base": "Knowledge Base",
        // support: "support",
        // support_dashboard: "Dashboard",
        // "support_create-ticket": "Create Ticket",
        // "support_my-tickets": "My Tickets",
        // "support_all-tickets": "All Tickets",
        // "support_ticket-details": "Ticket Details",
        models: "models",
        // assistants: "Assistants",
        // storage: "Storage",
        billing_history: "history",
        usage_reports: "reports",
        usage_overview: "overview",
        billing_credit: "credit",
        billing_packages: "packages",
        affiliate: "Affiliate",
        usage: "Usages",
        limits: "limits",
        billing: "billing",
        "api-keys": "API",
        login: "Login",
        403: "No Permission",
        404: "Page Not Found",
        500: "Server Error",
        home: "Home",
        exception: "Exception",
        exception_403: "403",
        exception_404: "404",
        exception_500: "500",
        // docs: 'Documents',
        // "docs_whats-new": "What's New",
        // docs_vision: "Computer Vision",
        // "docs_text-to-speech": "Text to Speech",
        // "docs_text-generation": "Text Generation",
        // "docs_structured-outputs": "Structured Outputs",
        // "docs_speech-to-text": "Speech to Text",
        // "docs_safety-best-practices": "Safety Best Practices",
        // docs_reasoning: "Reasoning & Logic",
        // "docs_release-notes": "Release Notes",
        // "docs_realtime-websocket": "WebSocket Integration",
        // "docs_realtime-webrtc": "WebRTC Integration",
        // "docs_realtime-model-capabilities": "Realtime Model Capabilities",
        // docs_realtime: "Realtime Features",
        // "docs_rate-limits": "Rate Limits",
        // docs_quickstart: "Quick Start Guide",
        // "docs_prompt-generation": "Prompt Generation",
        // "docs_prompt-examples": "Prompt Examples",
        // "docs_prompt-engineering": "Prompt Engineering",
        // "docs_prompt-caching": "Prompt Caching",
        // "docs_production-best-practices": "Production Best Practices",
        // "docs_predicted-outputs": "Predicted Outputs",
        // docs_overview: "Overview",
        // "docs_optimizing-llm-accuracy": "Optimizing LLM Accuracy",
        // docs_moderation: "Content Moderation",
        // docs_models: "Models",
        // "docs_model-selection": "Model Selection Guide",
        // docs_libraries: "Libraries & SDKs",
        // "docs_latency-optimization": "Latency Optimization",
        // "docs_image-generation": "Image Generation",
        // "docs_function-calling": "Function Calling",
        // "docs_fine-tuning": "Fine-tuning Models",
        // docs_evals: "Model Evaluations",
        // "docs_error-codes": "Error Codes",
        // docs_distillation: "Model Distillation",
        // docs_embeddings: "Embeddings",
        // docs_deprecations: "Deprecation Notices",
        // "docs_deep-dive": "Technical Deep Dive",
        // docs_changelog: "Changelog",
        // docs_batch: "Batch Processing",
        // docs_assistant_usage: "Assistant Usage Guide",
        // docs_assistant_tools: "Assistant Tools",
        // docs_assistant_quickstart: "Assistant Quick Start",
        // "docs_audio-generation": "Audio Generation",
        // "docs_assistant_whats-new": "Assistant Updates",
        // docs_assistant_overview: "Assistant Overview",
        // docs_assistant_tools_overview: "Tools Overview",
        // "docs_assistant_tools_function-calling": "Function Calling Tools",
        // "docs_assistant_tools_file-search": "File Search Tools",
        // "docs_assistant_tools_code-interpreter": "Code Interpreter",
        // docs_assistant_migration: "Assistant Migration Guide",
        // docs_assistant: "AI Assistant",
        // "docs_assistant_deep-dive": "Assistant Technical Details",
        // "docs_advanced-usage": "Advanced Usage",
        // "docs_actions_sending-files": "Sending Files with Actions",
        // docs_actions_production: "Actions in Production",
        // docs_actions_introduction: "Introduction to Actions",
        // docs: "Documentation",
        // "docs_accuracy-optimization": "Accuracy Optimization",
        // docs_actions: "Actions",
        // "docs_actions_actions-library": "Actions Library",
        // "docs_actions_data-retrieval": "Data Retrieval Actions",
        // docs_actions_authentication: "Actions Authentication",
        // "docs_actions_getting-started": "Getting Started with Actions",
    },
    page: {
        login: {
            common: {
                // visitAsGuest: 'Visit as guest',
                login: "Login",
                needLogin: "You need to login first",
                continueAsGuest: "Continue as Guest",
                loginBenefits: "Login to unlock full access to your dashboard",
                unlockFeatures: "Login to unlock:",
                loginRequired: "Login required for this action",
                loginOrRegister: "Login / Register",
                userNamePlaceholder: "Please enter user name",
                phonePlaceholder: "Please enter phone number",
                codePlaceholder: "Please enter verification code",
                passwordPlaceholder: "Please enter password",
                confirmPasswordPlaceholder: "Please enter password again",
                codeLogin: "Verification code login",
                confirm: "Confirm",
                back: "Back",
                validateSuccess: "Verification passed",
                loginSuccess: "Login successfully",
                welcomeBack: "Welcome back, {userName} !",
                benefits: {
                    "api-keys": {
                        a: "Create and manage API keys",
                        b: "Monitor API usage and costs",
                        c: "Configure rate limits and permissions",
                    },
                    billing: {
                        a: "View detailed billing history",
                        b: "Add credits to your account",
                        c: "Download invoices and receipts",
                    },
                    packages: {
                        a: "View and manage your credit packages",
                        b: "Purchase new credit packages",
                        c: "Monitor your credit packages",
                    },
                    home: {
                        a: "Access personalized dashboard",
                        b: "View real-time usage data",
                        c: "Customize settings and preferences",
                    },
                    models: {
                        a: "Access all available models",
                        b: "View detailed model information",
                        c: "Compare model capabilities",
                    },
                    usage: {
                        a: "Detailed usage analytics",
                        b: "Export usage reports",
                        c: "Track spending over time",
                    },
                    affiliate: {
                        a: "Earn commissions from referrals",
                        b: "Track invited users and earnings",
                        c: "Withdraw earned commissions",
                    },
                },
            },
            pwdLogin: {
                title: "Password Login",
                rememberMe: "Remember me",
                forgetPassword: "Forget password?",
                register: "Register",
                otherAccountLogin: "Other Account Login",
                otherLoginMode: "Other Login Mode",
                superAdmin: "Super Admin",
                admin: "Admin",
                user: "User",
            },
            codeLogin: {
                title: "Verification Code Login",
                getCode: "Get verification code",
                sendFailed: "Verification code failed, Please try again",
                reGetCode: "Reacquire after {time}s",
                sendCodeSuccess: "Verification code sent successfully",
                sendCodeSuccessViaFallback: "Verification code sent via {provider}",
                imageCodePlaceholder: "Please enter image verification code",
                codeNotValid: "Code not valid or expired",
                phoneAlreadyAssociated:
                    "This phone number already used, Please use another phone number",
                fallbackProvider: {
                    bale: "Bale Messenger",
                },
                fallbackProviderLink: {
                    bale: "https://web.bale.ai/",
                },
                openFallbackProvider: "Open {provider}",
                fallbackOtpTitle: "Alternative Verification Method",
                fallbackOtpWhyTitle: "Why am I seeing this?",
                fallbackOtpWhyDescription: "We tried to send you a verification code via SMS, but our SMS service is temporarily unavailable. To ensure you can still access your account securely, we have sent your verification code through an alternative channel.",
                fallbackOtpSmsNotResponding: "The SMS provider is not responding at the moment. Your code has been safely sent via {provider} instead.",
                fallbackOtpStep1: "We attempted to send an SMS but the service was unavailable",
                fallbackOtpStep2: "Your verification code has been securely sent to {provider}",
                fallbackOtpStep3: "Enter the code you received to complete verification",
                fallbackOtpAlternativeTitle: "Prefer to receive SMS?",
                fallbackOtpAlternativeDescription: "If you prefer to receive the verification code via SMS instead, you can wait a few minutes and try again. Our system always attempts SMS delivery first before using alternative methods.",
                fallbackOtpRetryLater: "Please wait a few minutes and try again. The SMS service may become available shortly.",
                fallbackOtpInfoButton: "Why this method?",
            },
            register: {
                title: "Register",
                agreement: "I have read and agree to",
                protocol: "《User Agreement》",
                policy: "《Privacy Policy》",
            },
            resetPwd: {
                title: "Reset Password",
            },
            bindWeChat: {
                title: "Bind WeChat",
            },
            guestMode: {
                message:
                    "You're browsing as a guest. Login for full access to all features.",
                timeRemaining: "Guest session expires in {time}",
                upgradePrompt:
                    "Enjoying the platform? Create an account to save your progress.",
            },
            benefits: {
                createApiKeys: "Create and manage API keys",
                manageKeys: "Full key management capabilities",
                viewUsage: "Detailed usage analytics",
                viewBilling: "Access billing history",
                addCredits: "Add credits and manage payments",
                downloadInvoices: "Download invoices and receipts",
                personalizedDashboard: "Personalized dashboard experience",
                realTimeData: "Real-time data and notifications",
                customSettings: "Custom settings and preferences",
            },
        },
        about: {
            title: "About",
            introduction: `Soybean Admin is an elegant and powerful admin template, based on the latest front-end technology stack, including Vue3, Vite5, TypeScript, Pinia and UnoCSS. It has built-in rich theme configuration and components, strict code specifications, and an automated file routing system. In addition, it also uses the online mock data solution based on ApiFox. Soybean Admin provides you with a one-stop admin solution, no additional configuration, and out of the box. It is also a best practice for learning cutting-edge technologies quickly.`,
            projectInfo: {
                title: "Project Info",
                version: "Version",
                latestBuildTime: "Latest Build Time",
                githubLink: "Github Link",
                previewLink: "Preview Link",
            },
            prdDep: "Production Dependency",
            devDep: "Development Dependency",
        },
        home: {
            offer1: "350 million Tomans",
            offer2: "550 million Tomans",
            offer3: "1 billion Tomans",
            offer1Benefit: "50 million Tomans",
            offer2Benefit: "100 million Tomans",
            offer3Benefit: "200 million Tomans",
            specialOffer: "Special Offer: Free credit up to 200 million Tomans!",
            inChargeMoreGetMore:
                "Top up your account and receive free credit. The more you top up, the more credit you get!",
            offerExpiresIn:
                "Offer is valid until November 21. Credit expires in 60 days.",
            shortDesc1: "Providing leading Artificial Intelligence services",
            // desc1Title: 'Easy Access',
            desc1:
                "AvalAI is your premier gateway to the most advanced artificial intelligence models available today. By registering a single developer account with us, you unlock access to a universe of opportunities. Our platform seamlessly integrates top AI services, including OpenAI, Anthropic, Meta, Mistral AI, Cohere, Google (Gemini) and Deepseek, with more providers on the horizon. All this is available at the official provider rates, with no additional costs.",
            desc2:
                "Experience hassle-free access with AvalAI. Our platform is designed to eliminate common barriers such as geographical restrictions, allowing you to focus solely on innovation. We offer secure transactions without hidden fees, immediate activation of user accounts, and an impressive 99.9% uptime of our infrastructure.",
            desc3:
                "At AvalAI, we are committed to providing a smooth and efficient experience for developers, researchers, and businesses alike. Leverage the power of leading AI technologies to propel your projects and ideas to new heights. Join us at AvalAI and start transforming the future today.",
            greeting: "Welcome",
            weatherDesc: "Today is cloudy to clear, 20℃ - 25℃!",
            projectCount: "Project Count",
            todo: "Todo",
            message: "Message",
            downloadCount: "Download Count",
            registerCount: "Register Count",
            schedule: "Work and rest Schedule",
            study: "Study",
            work: "Work",
            rest: "Rest",
            entertainment: "Entertainment",
            visitCount: "Visit Count",
            turnover: "Turnover",
            dealCount: "Deal Count",
            projectNews: {
                title: "Project News",
                moreNews: "More News",
                desc1: "",
                desc2: "",
                desc3: "",
                desc4: "",
                desc5: "",
            },
            creativity: "Creativity",
        },
        function: {
            tab: {
                tabOperate: {
                    title: "Tab Operation",
                    addTab: "Add Tab",
                    addTabDesc: "To about page",
                    closeTab: "Close Tab",
                    closeCurrentTab: "Close Current Tab",
                    closeAboutTab: 'Close "About" Tab',
                    addMultiTab: "Add Multi Tab",
                    addMultiTabDesc1: "To MultiTab page",
                    addMultiTabDesc2: "To MultiTab page(with query params)",
                },
                tabTitle: {
                    title: "Tab Title",
                    changeTitle: "Change Title",
                    change: "Change",
                    resetTitle: "Reset Title",
                    reset: "Reset",
                },
            },
            multiTab: {
                routeParam: "Route Param",
                backTab: "Back function_tab",
            },
            toggleAuth: {
                toggleAccount: "Toggle Account",
                authHook: "Auth Hook Function `hasAuth`",
                superAdminVisible: "Super Admin Visible",
                adminVisible: "Admin Visible",
                adminOrUserVisible: "Admin and User Visible",
            },
        },
        manage: {
            common: {
                status: {
                    enable: "Enable",
                    disable: "Disable",
                },
            },
            role: {
                title: "Role List",
                roleName: "Role Name",
                roleCode: "Role Code",
                roleStatus: "Role Status",
                roleDesc: "Role Description",
                menuAuth: "Menu Auth",
                buttonAuth: "Button Auth",
                form: {
                    roleName: "Please enter role name",
                    roleCode: "Please enter role code",
                    roleStatus: "Please select role status",
                    roleDesc: "Please enter role description",
                },
                addRole: "Add Role",
                editRole: "Edit Role",
            },
            user: {
                title: "User List",
                userName: "User Name",
                userGender: "Gender",
                nickName: "Nick Name",
                userPhone: "Phone Number",
                userEmail: "Email",
                userStatus: "User Status",
                userRole: "User Role",
                form: {
                    userName: "Please enter user name",
                    userGender: "Please select gender",
                    nickName: "Please enter nick name",
                    userPhone: "Please enter phone number",
                    userEmail: "Please enter email",
                    userStatus: "Please select user status",
                    userRole: "Please select user role",
                },
                addUser: "Add User",
                editUser: "Edit User",
                gender: {
                    male: "Male",
                    female: "Female",
                },
            },
            menu: {
                home: "Home",
                title: "Menu List",
                id: "ID",
                parentId: "Parent ID",
                menuType: "Menu Type",
                menuName: "Menu Name",
                routeName: "Route Name",
                routePath: "Route Path",
                routeParams: "Route Params",
                layout: "Layout Component",
                page: "Page Component",
                i18nKey: "I18n Key",
                icon: "Icon",
                localIcon: "Local Icon",
                iconTypeTitle: "Icon Type",
                order: "Order",
                keepAlive: "Keep Alive",
                href: "Href",
                hideInMenu: "Hide In Menu",
                activeMenu: "Active Menu",
                multiTab: "Multi Tab",
                fixedIndexInTab: "Fixed Index In Tab",
                button: "Button",
                buttonCode: "Button Code",
                buttonDesc: "Button Desc",
                menuStatus: "Menu Status",
                form: {
                    home: "Please select home",
                    menuType: "Please select menu type",
                    menuName: "Please enter menu name",
                    routeName: "Please enter route name",
                    routePath: "Please enter route path",
                    page: "Please select page component",
                    layout: "Please select layout component",
                    i18nKey: "Please enter i18n key",
                    icon: "Please enter iconify name",
                    localIcon: "Please enter local icon name",
                    order: "Please enter order",
                    keepAlive: "Please select whether to cache route",
                    href: "Please enter href",
                    hideInMenu: "Please select whether to hide menu",
                    activeMenu: "Please enter the route name of the highlighted menu",
                    multiTab: "Please select whether to support multiple tabs",
                    fixedInTab: "Please select whether to fix in the tab",
                    fixedIndexInTab: "Please enter the index fixed in the tab",
                    button: "Please select whether it is a button",
                    buttonCode: "Please enter button code",
                    buttonDesc: "Please enter button description",
                    menuStatus: "Please select menu status",
                },
                addMenu: "Add Menu",
                editMenu: "Edit Menu",
                addChildMenu: "Add Child Menu",
                type: {
                    directory: "Directory",
                    menu: "Menu",
                },
                iconType: {
                    iconify: "Iconify Icon",
                    local: "Local Icon",
                },
            },
        },
    },
    form: {
        required: "Cannot be empty",
        userName: {
            required: "Please enter user name",
            invalid: "User name format is incorrect",
        },
        phone: {
            required: "Please enter phone number",
            invalid: "Phone number format is incorrect",
        },
        pwd: {
            required: "Please enter password",
            invalid: "6-18 characters, including letters, numbers, and underscores",
        },
        confirmPwd: {
            required: "Please enter password again",
            invalid: "The two passwords are inconsistent",
        },
        code: {
            required: "Please enter verification code",
            invalid: "Verification code format is incorrect",
        },
        email: {
            required: "Please enter email",
            invalid: "Email format is incorrect",
        },
    },
    dropdown: {
        closeCurrent: "Close Current",
        closeOther: "Close Other",
        closeLeft: "Close Left",
        closeRight: "Close Right",
        closeAll: "Close All",
    },
    icon: {
        themeConfig: "Theme Configuration",
        themeSchema: "Theme Schema",
        lang: "Switch Language",
        fullscreen: "Fullscreen",
        fullscreenExit: "Exit Fullscreen",
        reload: "Reload Page",
        collapse: "Collapse Menu",
        expand: "Expand Menu",
        pin: "Pin",
        unpin: "Unpin",
    },
    storage: {
        uploadModalTitle: "Upload a File",
        fileSelected: "File selected",
        uploadFilePlaceholder: "Upload a file or drag and drop here",
        fileNameLabel: "Name",
        fileNameDescription: "The name of the uploaded file",
        fileNamePlaceholder: "Enter file name",
        purposeLabel: "Purpose",
        purposeDescription: "The purpose of the uploaded file",
        purposePlaceholder: "Select purpose",
        learnMoreLink: "Learn about file purposes",
        searchFilesPlaceholder: "Search files ...",
        invalidFileType: "Invalid file type for {purpose}",
        supportedFormatsAssistants: "Supported formats: {formats}",
        supportedFormatsVision: "Supported formats: {formats}",
        supportedFormatsJsonl: "Only .jsonl files are supported",
        fileNotFound: "File not found",
        fileUploadedButNotListed: "File uploaded but not yet visible in list",
        fileUploadedAndListed: "File uploaded and confirmed in list",
        downloadStarting: "Starting download...",
        downloading: "Downloading...",
        downloadComplete: "Download complete",
        downloadError: "Error downloading file",
        file: "File",
        status: "Status",
        fileId: "File ID",
        purpose: "Purpose",
        size: "Size",
        createdAt: "Created at",
        download: "Download",
        delete: "Delete",
        deleteConfirm: "Are you sure you want to delete this file?",
        selectFile: "Select a file to view details",
        files: "Files",
        vectorStores: "Vector Stores",
        upload: "Upload",
        noFiles: "No files uploaded",
        noVectorStores: "No vector stores created",
        selectItem: "Select an item to view details",
        uploadSuccess: "File uploaded successfully",
        uploadError: "Failed to upload file",
        fileDeleted: "File deleted successfully",
        deleteError: "Failed to delete file",
        fetchError: "Failed to fetch data",
    },
    assistants: {
        vectorStore: "Vector Store",
        noAssistants: "No assistants found",
        createAssistantGetStarted:
            "Create an assistant to get started with Assistants API.",
        defineResponseSchema: "Define Response Schema",
        responseSchemaDescription:
            "Define the JSON schema for the assistant's responses",
        enterVectorStoreId: "Enter vector store Id",
        selectExisting: "Select Existing",
        uploadNew: "Upload New",
        uploadFile: "Upload File",
        generate: "Generate",
        examples: "Examples",
        getStockPrice: "Get Stock Price",
        weatherForecast: "Weather Forecast",
        calculator: "Calculator",
        functions: "Functions",
        addFunction: "Add Function",
        editFunction: "Edit Function",
        removeFunction: "Remove Function",
        functionName: "Function Name",
        functionDescription:
            "Define a function that the assistant can call. The function should be defined using JSON Schema format.",
        functionDefinitionPlaceholder:
            "   Enter function definition in JSON Schema format...",
        definition: "Function Definition",
        strictMode: "Strict Mode",
        strictModeHelp:
            "When enabled, the assistant will only call functions exactly as defined. Disable for more flexible function calling.",
        invalidDefinition:
            "Invalid function definition. Please check the JSON Schema format.",
        duplicateFunctionName: "A function with this name already exists.",
        functionRequired: "Function definition is required",
        generateFunction: "Generate Function",
        exampleFunctions: "Example Functions",
        functionSaved: "Function saved successfully",
        functionRemoved: "Function removed successfully",
        functionValidationError:
            "Function validation failed. Please check the definition.",
        learnMoreFunctions: "Learn more about function definitions",
        modelRequired: "Model is required",
        responseFormatRequired: "Response format is required",
        temperatureInvalid: "Temperature must be between 0 and 2",
        topPInvalid: "Top P must be between 0 and 1",
        maxResultsInvalid: "Max results must be within the allowed range",
        title: "Assistants",
        selectToView: "Select an assistant to view details",
        createNew: "Create New Assistant",
        name: "Name",
        namePlaceholder: "Enter a user friendly name",
        nameRequired: "Name is required",
        instructions: "Instructions",
        instructionsPlaceholder: "You are a helpful assistant...",
        instructionsRequired: "Instructions are required",
        model: "Model",
        tools: "Tools",
        fileSearch: "File Search",
        codeInterpreter: "Code Interpreter",
        addFiles: "Add Files",
        selectVectorStore: "Select Vector Store",
        modelConfig: "Model Configuration",
        responseFormat: "Response Format",
        temperature: "Temperature",
        topP: "Top P",
        maxResults: "Max Results",
        maxResultsHelp: "Maximum number of results to return from file search",
        create: "Create",
        attachFiles: "Attach Files to File Search",
        attachVectorStore: "Attach Vector Store",
        dragFilesHere: "Drag your files here",
        clickToUpload: "Click to Upload",
        fileUploadHelp:
            "Files will be processed and made available for the assistant to search through",
        vectorStoreHelp:
            "Select an existing vector store to allow the assistant to search through its contents",
        searchVectorStores: "Search vector stores...",
        noVectorStoresFound: "No vector stores found",
        vectorStoreSearchPlaceholder: "Enter vector store id",
        attach: "Attach",
        back: "Back",
        learnMore: "Learn more",
        fileName: "File Name",
        fileSize: "Size",
        fileStatus: "Status",
        fileActions: "Actions",
        removeFile: "Remove",
        fileAttached: "File attached successfully",
        vectorStoreAttached: "Vector store attached successfully",
        fileRemoved: "File removed",
        invalidFileType: "Invalid file type",
        fileTooLarge: "File is too large",
        uploadError: "Error uploading file",
        temperatureHelp: "Controls randomness in the assistant's responses",
        topPHelp: "Controls diversity of the assistant's responses",
        fileSearchHelp: "Enable searching through attached files",
        codeInterpreterHelp: "Enable Python code execution capabilities",
    },
};

export default local;

